/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React, { useContext } from 'react';

import NetworkOverlays from './NetworkOverlays';
import OverlaysWrapper from './OverlaysWrapper';
import { OverlaysContextsEnum } from '../../../store/maps/reducer';
import { MapActionsContext, useSelectorWithMapId } from '../map/BaseMapContainer';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  selectFlightLegServiceAlerts,
  selectOverlaysCurrentContext,
  selectOverlaysPanelShown,
  selectSelectedOverlaidFlightLegId,
  selectUserData,
} from '../../../store';
import GpsSaOverlays from './GpsSaOverlays';
import { StyledDivider } from './CommonOverlayComponents';
import { Authorities } from '../../../shared/entities/user';
import { areAllowedRolesPresent } from '../../../utils/RBACUtils';

const OVERLAYS_PANEL_TOP_PX = 67;

export function OverlaysPanel() {
  const dispatch = useDispatch();
  const mapActionsContext = useContext(MapActionsContext);
  const { hideOverlaysPanel } = mapActionsContext.mapActions;

  const overlaysPanelShown = useSelectorWithMapId(selectOverlaysPanelShown);
  const overlaysCurrentContext = useSelector(selectOverlaysCurrentContext);
  const selectedOverlaidFlightLegId = useSelectorWithMapId(selectSelectedOverlaidFlightLegId);
  const flightLegServiceAlerts = useSelector(selectFlightLegServiceAlerts);
  const userData = useSelector(selectUserData, shallowEqual);

  const top = OVERLAYS_PANEL_TOP_PX + 'px';

  const isPerformanceOutlook = overlaysCurrentContext === OverlaysContextsEnum.PERFORMANCE_OUTLOOK;

  return (
    <OverlaysWrapper
      headerTitle="Map Overlays"
      queryParamsToNotHidePanel={['#overlays_panel_btn_container', '.select__menu']}
      shown={overlaysPanelShown}
      hidePanel={() => {
        dispatch(hideOverlaysPanel());
      }}
      top={top}
    >
      <NetworkOverlays
        isPerformanceOutlookView={isPerformanceOutlook}
        selectedOverlaidFlightLegId={selectedOverlaidFlightLegId}
        flightLegServiceAlerts={flightLegServiceAlerts}
      />
      {userData && areAllowedRolesPresent(userData, Authorities.ROLE_DEV_VIEW_ONLY, Authorities.ROLE_GPS_SA_OVERLAY) ? (
        <>
          <StyledDivider />
          <GpsSaOverlays />
        </>
      ) : null}
    </OverlaysWrapper>
  );
}

export default OverlaysPanel;
